// game/barks.ts — "the Deep Speaks" ticker. One line at a time, 3s, fades out.
// Our voice, not anyone else's: grim, terse, a little wry.

const HOLD = 3

class Barks {
  private queue: string[] = []
  private current = ''
  private t = 0

  clear(): void {
    this.queue.length = 0
    this.current = ''
    this.t = 0
  }

  push(text: string): void {
    if (!text) return
    if (this.current === text || this.queue[this.queue.length - 1] === text) return
    if (this.queue.length > 6) this.queue.shift()
    this.queue.push(text)
  }

  update(dt: number): void {
    if (this.t > 0) {
      this.t -= dt
      if (this.t <= 0) this.current = ''
    }
    if (!this.current && this.queue.length) {
      this.current = this.queue.shift() as string
      this.t = HOLD
    }
  }

  get active(): string {
    return this.current
  }

  render(ctx: CanvasRenderingContext2D, w: number, h: number, pos: 'bottom' | 'top' = 'bottom'): void {
    if (!this.current) return
    const k = Math.min(1, this.t / 0.6) * Math.min(1, (HOLD - this.t) / 0.18 + 0.2)
    const a = Math.max(0, Math.min(1, k))
    const y = pos === 'top' ? 108 : h - 42
    ctx.font = '600 17px ui-monospace, "SF Mono", Menlo, monospace'
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'
    const tw = ctx.measureText(this.current).width
    ctx.globalAlpha = a * 0.55
    ctx.fillStyle = '#05060a'
    ctx.fillRect(w / 2 - tw / 2 - 16, y - 16, tw + 32, 32)
    ctx.globalAlpha = a * 0.35
    ctx.fillStyle = '#c9a227'
    ctx.fillRect(w / 2 - tw / 2 - 16, y - 16, tw + 32, 1)
    ctx.fillRect(w / 2 - tw / 2 - 16, y + 15, tw + 32, 1)
    ctx.globalAlpha = a
    ctx.fillStyle = '#000000'
    ctx.fillText(this.current, w / 2 + 1, y + 1)
    ctx.fillStyle = '#e8dcbf'
    ctx.fillText(this.current, w / 2, y)
    ctx.globalAlpha = 1
  }
}

export const barks = new Barks()
